import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mdb_modal_title = _resolveComponent("mdb-modal-title")!
  const _component_mdb_modal_header = _resolveComponent("mdb-modal-header")!
  const _component_error = _resolveComponent("error")!
  const _component_mdb_modal_body = _resolveComponent("mdb-modal-body")!
  const _component_mdb_modal = _resolveComponent("mdb-modal")!

  return (_ctx.hasErrors)
    ? (_openBlock(), _createBlock(_component_mdb_modal, {
        key: 0,
        show: _ctx.showErrorPopup,
        onClose: _ctx.HIDE_ERROR_POPUP,
        class: "text-black-50",
        position: "top",
        size: "sm",
        color: "danger"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_mdb_modal_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_mdb_modal_title, null, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("Что-то пошло не так", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_mdb_modal_body, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                return (_openBlock(), _createBlock(_component_error, _mergeProps({ key: index }, { ref_for: true }, error, {
                  onDelete: ($event: any) => (_ctx.FLUSH_ERROR(index))
                }), null, 16 /* FULL_PROPS */, ["onDelete"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["show", "onClose"]))
    : _createCommentVNode("v-if", true)
}